import { getAxiosClient } from './common';

const axios = getAxiosClient();

export async function orderPrelimTitleReport({ parcelIds, projectId }: { parcelIds: string[]; projectId: string }) {
  const { data } = await axios({
    method: 'POST',
    url: `/v1/title/orderPrelimTitleReport`,
    data: {
      parcelIds,
      projectId,
    },
  });
  return data;
}

export const getParcelDetails = async ({ parcelId, projectId }: { parcelId: string; projectId: string }) => {
  const { data } = await axios({
    method: 'GET',
    url: `/v1/title/getParcelDetails?parcelId=${parcelId}&projectId=${projectId}`,
  });
  return data;
};
